var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6C15.75 5.58579 15.4142 5.25 15 5.25C14.5858 5.25 14.25 5.58579 14.25 6H15.75ZM14.25 18C14.25 18.4142 14.5858 18.75 15 18.75C15.4142 18.75 15.75 18.4142 15.75 18H14.25ZM14.25 6V18H15.75V6H14.25Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9C17.25 8.58579 17.5858 8.25 18 8.25C18.4142 8.25 18.75 8.58579 18.75 9L17.25 9ZM18.75 15C18.75 15.4142 18.4142 15.75 18 15.75C17.5858 15.75 17.25 15.4142 17.25 15L18.75 15ZM18.75 9L18.75 15L17.25 15L17.25 9L18.75 9Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26449 9.26449C9.11842 9.11842 8.88158 9.11842 8.73551 9.26449C8.58952 9.41048 8.58942 9.64713 8.73527 9.79324L10.5638 11.625H6.375C6.16789 11.625 6 11.7929 6 12C6 12.2071 6.16789 12.375 6.375 12.375H10.5638L8.73527 14.2068C8.58942 14.3529 8.58952 14.5895 8.73551 14.7355C8.88158 14.8816 9.11842 14.8816 9.26449 14.7355L11.2929 12.7071C11.6834 12.3166 11.6834 11.6834 11.2929 11.2929L9.26449 9.26449Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44127 9.08772C9.19756 8.84401 8.80244 8.84401 8.55873 9.08772C8.31518 9.33127 8.315 9.72609 8.55834 9.96986L9.96096 11.375H6.375C6.02982 11.375 5.75 11.6548 5.75 12C5.75 12.3452 6.02982 12.625 6.375 12.625H9.96096L8.55834 14.0301C8.315 14.2739 8.31518 14.6687 8.55873 14.9123C8.80244 15.156 9.19756 15.156 9.44127 14.9123L11.4697 12.8839C11.9578 12.3957 11.9578 11.6043 11.4697 11.1161L9.44127 9.08772Z",
    stroke: "currentColor",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.5fbccfa4.svg";
export { ForwardRef as ReactComponent };